<ng-container *ngIf="auth.loggedInUser">
  <app-warehouse-profile *ngIf="!auth.IsCarrier()"></app-warehouse-profile>
  <app-carrier-profile *ngIf="auth.IsCarrier()"></app-carrier-profile>
</ng-container>
